import axios from 'axios';
import { formatAxiosErrorMessage } from '../utils/verboseHttpError';

let showErrorFn = null;
let logoutFn = null;

export const registerErrorDisplay = (fn) => {
  showErrorFn = fn;
};

export const registerLogoutFn = (fn) => {
  logoutFn = fn;
};

const instance = axios.create();

// Configurazione globale di Axios
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config?.skipGlobalErrorHandler) {
      return Promise.reject(error);
    }
    
    // Gestione Unauthorized/Forbidden globale
    if (error.response?.status === 401 || error.response?.status === 403) {
      if (logoutFn) {
        logoutFn();
      }
      return Promise.reject(error);
    }

    const message = formatAxiosErrorMessage(error);

    // Se la funzione di visualizzazione è registrata, mostra l'errore
    if (showErrorFn) {
      showErrorFn(message);
    }

    return Promise.reject(error);
  }
);

export default instance;
 